var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3333 6.70836C15.3333 6.17908 15.7624 5.75002 16.2917 5.75002C16.821 5.75002 17.25 6.17908 17.25 6.70836C17.25 7.23763 16.821 7.66669 16.2917 7.66669C15.7624 7.66669 15.3333 7.23763 15.3333 6.70836Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5 6.94794C8.98597 6.94794 6.94793 8.98598 6.94793 11.5C6.94793 14.0141 8.98597 16.0521 11.5 16.0521C14.0141 16.0521 16.0521 14.0141 16.0521 11.5C16.0521 8.98598 14.0141 6.94794 11.5 6.94794ZM8.38543 11.5C8.38543 9.77989 9.77988 8.38544 11.5 8.38544C13.2201 8.38544 14.6146 9.77989 14.6146 11.5C14.6146 13.2202 13.2201 14.6146 11.5 14.6146C9.77988 14.6146 8.38543 13.2202 8.38543 11.5Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5392 2.715C13.217 2.3437 9.78301 2.3437 6.46088 2.715C4.53265 2.9305 2.976 4.44947 2.7493 6.38773C2.35204 9.78435 2.35204 13.2157 2.7493 16.6123C2.976 18.5506 4.53265 20.0695 6.46088 20.285C9.78301 20.6563 13.217 20.6563 16.5392 20.285C18.4674 20.0695 20.024 18.5506 20.2507 16.6123C20.648 13.2157 20.648 9.78435 20.2507 6.38773C20.024 4.44947 18.4674 2.9305 16.5392 2.715ZM6.62054 4.1436C9.83656 3.78416 13.1635 3.78416 16.3795 4.1436C17.6542 4.28607 18.6753 5.29195 18.823 6.55472C19.2073 9.84039 19.2073 13.1597 18.823 16.4453C18.6753 17.7081 17.6542 18.714 16.3795 18.8564C13.1635 19.2159 9.83656 19.2159 6.62054 18.8564C5.34586 18.714 4.32476 17.7081 4.17707 16.4453C3.79278 13.1597 3.79278 9.84039 4.17707 6.55472C4.32476 5.29195 5.34586 4.28607 6.62054 4.1436Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/Instagram.a393a2ff782d88cbd476a372819df37d.svg";
export { ForwardRef as ReactComponent };